import React from 'react'
import { Avatar, Button, Card, Divider, Row, Col, Tooltip, Tag } from 'antd';
import {
    FormOutlined,
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    FileTextOutlined,
    TeamOutlined,
} from '@ant-design/icons';
import { IMAGE_API, usuario } from '../../resources';

// parent component: expedientes/expedientes.jsx

export default function DetallesPaciente({ paciente, setIsEditModalOpen }) {

    const isMedic = usuario && usuario.rol && usuario.rol === 'Medico';

    const InfoItem = ({ icon, label, value }) => (
        <div style={{
            background: '#f8f9fc',
            borderRadius: 8,
            padding: '10px 14px',
            border: '1px solid #eef0f5',
            marginBottom: 8,
            transition: 'box-shadow 0.2s ease',
        }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                {icon && <span style={{ color: '#7b8794', fontSize: 12 }}>{icon}</span>}
                <span style={{ fontSize: 11, fontWeight: 600, color: '#7b8794', textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</span>
            </div>
            <span style={{ fontSize: 14, fontWeight: 500, color: '#2a2a3a' }}>{value || '—'}</span>
        </div>
    )

    return (
        <Card
            style={{
                marginTop: 16,
                width: isMedic ? '50%' : '100%',
                borderRadius: 10,
                border: '1px solid #eef0f5',
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
            }}
            bodyStyle={{ padding: '20px 24px' }}
        >
            {/* Avatar + Name Header */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 4 }}>
                <div style={{
                    borderRadius: '50%',
                    padding: 3,
                    background: 'linear-gradient(135deg, #3c75ef 0%, #6ea8fe 100%)',
                    display: 'inline-flex',
                    marginBottom: 12,
                }}>
                    {
                        paciente.avatar && paciente.avatar.length > 9 ?
                            <img
                                width={82}
                                height={82}
                                src={IMAGE_API + paciente.avatar}
                                alt='ProfilePic'
                                style={{ borderRadius: '50%', objectFit: 'cover', border: '3px solid #fff' }}
                            />
                            :
                            <Avatar
                                size={82}
                                icon={<UserOutlined />}
                                style={{
                                    backgroundColor: '#e8edf5',
                                    color: '#3c75ef',
                                    border: '3px solid #fff',
                                    fontSize: 32,
                                }}
                            />
                    }
                </div>

                <h4 style={{ margin: 0, fontSize: 17, fontWeight: 600, color: '#1a1a2e', textAlign: 'center' }}>
                    {paciente.name}
                </h4>

                {
                    paciente.no_expediente &&
                    <Tag color="blue" style={{ borderRadius: 12, marginTop: 6, fontSize: 12 }}>
                        Folio: {paciente.no_expediente}
                    </Tag>
                }
            </div>

            <Divider style={{ margin: '14px 0' }} />

            {/* Contact Info */}
            <Row gutter={[12, 0]}>
                <Col span={12}>
                    <InfoItem
                        icon={<MailOutlined />}
                        label="Correo"
                        value={paciente.email}
                    />
                </Col>
                <Col span={12}>
                    <InfoItem
                        icon={<PhoneOutlined />}
                        label="Teléfono"
                        value={paciente.telefono}
                    />
                </Col>
            </Row>

            <Row gutter={[12, 0]}>
                <Col span={12}>
                    <InfoItem
                        icon={<CalendarOutlined />}
                        label="Fecha de nacimiento"
                        value={paciente.fecha_nacimiento ? new Date(paciente.fecha_nacimiento).toLocaleDateString() : null}
                    />
                </Col>
                <Col span={12}>
                    <InfoItem
                        icon={<FileTextOutlined />}
                        label="No. de Folio"
                        value={paciente.no_expediente}
                    />
                </Col>
            </Row>

            {/* Responsable */}
            {
                (paciente.responsable?.nombre || paciente.responsable?.telefono) && <>
                    <Divider style={{ margin: '8px 0 14px' }} />

                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                        <TeamOutlined style={{ fontSize: 15, color: '#3c75ef' }} />
                        <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e' }}>Responsable</span>
                    </div>

                    <Row gutter={[12, 0]}>
                        {
                            paciente.responsable.nombre &&
                            <Col span={12}>
                                <InfoItem
                                    icon={<UserOutlined />}
                                    label="Nombre"
                                    value={paciente.responsable.nombre}
                                />
                            </Col>
                        }
                        {
                            paciente.responsable.telefono &&
                            <Col span={12}>
                                <InfoItem
                                    icon={<PhoneOutlined />}
                                    label="Teléfono"
                                    value={paciente.responsable.telefono}
                                />
                            </Col>
                        }
                    </Row>
                </>
            }

            {/* Edit Button */}
            {
                isMedic &&
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                    <Tooltip title="Editar datos del paciente">
                        <Button
                            className='btnIconCentered'
                            onClick={() => setIsEditModalOpen(true)}
                            size='small'
                            type="primary"
                            shape='round'
                            icon={<FormOutlined />}
                            ghost
                        >
                            Editar paciente
                        </Button>
                    </Tooltip>
                </div>
            }
        </Card>
    )
}
